<template>
  <div class="payRedirect">

  </div>
</template>

<script>
// @ is an alias to /src
import * as API_PAY from '@/api/pay'

export default {
  name: 'PayRedirect',
  components: {

  },
  computed: {

  },
  async mounted() {

  },
  created() {
    this.payLogin()
  },
  methods: {
    /* 获取支付信息 */
    payLogin() {
      API_PAY.payLogin({ token: this.$route.query.token }).then(async res=> {
        // console.log(res)
        if (res.data.tradeSerialNo) {
          await this.$store.dispatch('token', res.data.token)
          await this.$store.dispatch('user', res.data.user)
          this.$router.push({ path: 'pay?tradeSerialNo=' + res.data.tradeSerialNo })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>